/**
 * data-section: section id
 * data-trigger: a selector for the element that triggers the animation. the target needs to be a child of <hh-animate-on-hover>
 * data-target: a selector (including '.', '#') for the element that will animate. (this can be anywhere in the document)
 * data-target-class: class of target element
 * data-class: class to be applied
 */

class HHAnimateOnHover extends HTMLElement {
  connectedCallback() {
    this.section = document.querySelector(this.dataset.section)
    this.trigger = this.querySelector(this.dataset.trigger)
    this.target = this.section.querySelector(this.dataset.target)
    this.targetItems = this.section.querySelectorAll(this.dataset.targetClass)
    this.addClass = this.dataset.class
    this.handleChange = this.handleChange.bind(this)

    this.trigger?.addEventListener('mouseover', this.handleChange)
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('mouseover', this.handleChange)
  }

  handleChange() {
    this.targetItems.forEach((item) => item.classList.remove(this.addClass))
    this.target.classList.add(this.addClass)
  }
}

customElements.define('hh-animate-on-hover', HHAnimateOnHover)
